import React, { useState } from 'react';
import { cloneDeep } from 'lodash';
import MerchantLogo from '../merchant-logo';

import './merchant-select-modal.scss';

const MerchantSelectModal = ({ closeModal, merchantItems, updateMerchants, resetCarousel }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [merchants, setMerchants] = useState(merchantItems);
  const [clearCarousel, setResetCarousel] = useState(resetCarousel);

  const numberSelected = merchants.filter(merch => merch.selected).length;

  function filterByName(e) {
    const searchTerm = e.target.value;
    const searchedMerchants = merchantItems.filter(merchant => {
      const name = merchant.full_name || '';
      return name.toLowerCase().startsWith(searchTerm.toLowerCase());
    });

    setSearchTerm(searchTerm);
    setMerchants(searchedMerchants);
  }

  function select(slug) {
    const newMerchants = cloneDeep(merchants);

    if (numberSelected === merchants.length) {
      newMerchants.map(merch => (merch.selected = false));
    }

    const merch = newMerchants.filter(merch => merch.slug === slug)[0];
    merch.selected = !merch.selected;

    setMerchants(newMerchants);
    setResetCarousel(false);
  }

  function confirm() {
    const newMerchants = cloneDeep(merchantItems);
    const selectedMerchIds = merchants.filter(merch => merch.selected).map(merch => merch.merch_id);
    /*
     * Select merchant if:
     * there are no merchants in view, none are selected, or it is selected
     */
    newMerchants.map(
      merch =>
        (merch.selected =
          !merchants.length ||
          !selectedMerchIds.length ||
          selectedMerchIds.includes(merch.merch_id)),
    );

    const resetCarousel = !numberSelected;
    updateMerchants(newMerchants, false, resetCarousel);
    closeModal();
  }

  function changeAll(selected) {
    const newMerchants = cloneDeep(merchants);
    newMerchants.map(merch => (merch.selected = selected));
    setMerchants(newMerchants);
  }

  const merchantList = merchants.map(merch => {
    const { slug } = merch;
    return (
      <MerchantLogo
        key={slug}
        merchant={merch}
        insightsType="product-research"
        selectMerchant={select}
        resetCarousel={clearCarousel}
      />
    );
  });

  const resetAll = <button onClick={() => changeAll(false)}>Reset</button>;

  const numSelected = clearCarousel ? 0 : numberSelected;
  const numberSelectedTxt = numSelected
    ? `${numberSelected} Merchant${numberSelected === 1 ? '' : 's'} Selected`
    : '';

  return (
    <div className="merchant-select-modal-container" onClick={closeModal}>
      <div className="merchant-select-modal modal movable-right" onClick={e => e.stopPropagation()}>
        <div className="header">
          <h3>Select Multiple Merchants</h3>
          <h4>Select multiple merchants to view transactional data</h4>
        </div>
        <div className="merchant-search">
          <button className="search-icon"></button>
          <input type="text" placeholder="Search" value={searchTerm} onChange={filterByName} />
        </div>
        <div className="merchant-list-header">
          <div className="number-merchants">
            {`${merchants.length} Merchant${merchants.length === 1 ? '' : 's'}`}
          </div>
          <div>{resetAll}</div>
        </div>
        <div className="merchant-list">{merchantList}</div>
        <div className="footer">
          <div className="number-merchants">{numberSelectedTxt}</div>
          <div>
            <button className="cancel-btn" onClick={closeModal}>
              Cancel
            </button>
            <button className="confirm-btn" onClick={confirm}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantSelectModal;
